import React from "react";
import { FaTimes } from "react-icons/fa";
import { HiCheckCircle, HiExclamationCircle } from "react-icons/hi";

const MessageBox = ({ error, success, onClick, message }) => {
  if (!error && !success) return null;

  const variant = success ? "success" : "error";

  const styles = {
    success: {
      container: "bg-emerald-50 border-emerald-200",
      title: "text-emerald-800",
      text: "text-emerald-700",
      icon: <HiCheckCircle className="h-5 w-5 text-emerald-600" aria-hidden="true" />,
      aria: "polite",
      label: "Success",
    },
    error: {
      container: "bg-red-50 border-red-200",
      title: "text-red-800",
      text: "text-red-700",
      icon: <HiExclamationCircle className="h-5 w-5 text-red-600" aria-hidden="true" />,
      aria: "assertive",
      label: "Error",
    },
  }[variant];

  return (
    <div
      role="alert"
      aria-live={styles.aria}
      onClick={onClick}
      className={`w-full cursor-pointer rounded-xl border px-4 py-3 shadow-sm ${styles.container}`}
    >
      <div className="flex items-start gap-3">
        <div className="mt-0.5">{styles.icon}</div>
        <div className="flex-1">
          <p className={`text-xs font-semibold tracking-wide uppercase ${styles.title}`}>
            {styles.label}
          </p>
          <p className={`mt-0.5 text-sm leading-5 ${styles.text}`}>
            {message}
          </p>
        </div>
        <button
          onClick={onClick}
          type="button"
          className="ml-2 inline-flex h-7 w-7 items-center justify-center rounded-md border border-black/10 bg-white text-gray-500 hover:text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
          aria-label="Dismiss message"
        >
          <FaTimes className="text-sm" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default MessageBox;
